import type en from "../en/orders";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  financialPending: "Paiement en attente",
  financialAwaitingAction: "En attente du client",
  financialAuthorized: "Autorisé",
  financialPaid: "Payée",
  financialPartiallyRefunded: "Partiellement remboursée",
  financialRefunded: "Remboursée",
  financialFailed: "Paiement échoué",
  financialCancelled: "Paiement annulé",
  financialDisputed: "Contestée",
  fulfillmentUnfulfilled: "Non expédiée",
  fulfillmentPartiallyFulfilled: "Partiellement expédiée",
  fulfillmentFulfilled: "Expédiée",
  fulfillmentNotRequired: "Sans livraison",
  orderOpen: "Ouverte",
  orderCompleted: "Terminée",
  orderCancelled: "Annulée",
  returnRequested: "Demandé",
  returnApproved: "Approuvé",
  returnRejected: "Refusé",
  returnReceived: "Reçu",
  returnRefunded: "Remboursé",
  returnClosed: "Clôturé",
  paymentPending: "En attente",
  paymentAwaitingAction: "Action requise",
  paymentAuthorized: "Autorisé",
  paymentCaptured: "Encaissé",
  paymentFailed: "Échoué",
  paymentCancelled: "Annulé",
  paymentPartiallyRefunded: "Partiellement remboursé",
  paymentRefunded: "Remboursé",
  paymentDisputed: "Contesté",
  paymentChargeback: "Rétrofacturation",
  shipmentShipped: "Expédié",
  shipmentDelivered: "Livré",
  shipmentCancelled: "Annulé",
  refundSucceeded: "Remboursé",
  refundPending: "En attente chez le prestataire",
  refundFailed: "Échoué",

  noticePaid: "Paiement enregistré comme reçu. Cette action a été consignée dans le journal d’audit.",
  noticeCancelled: "Commande annulée.",
  noticeShipped: "Expédition créée.",
  noticeDelivered: "Expédition marquée comme livrée.",
  noticeRefunded: "Remboursement envoyé sur le moyen de paiement d’origine du client via le prestataire de paiement.",
  noticeRefundedManual: "Remboursement enregistré. Aucun argent n’a été transféré automatiquement — remboursez vous-même le client.",
  noticeRefundPending: "Remboursement soumis et en attente chez le prestataire. Utilisez « Vérifier le remboursement » pour le confirmer.",
  noticeRefundCompleted: "Le remboursement en attente est confirmé comme effectué.",
  noticeReturnApproved: "Retour approuvé.",
  noticeReturnRejected: "Retour refusé.",
  noticeReturnReceived: "Retour marqué comme reçu.",
  noticeReturnClosed: "Retour clôturé.",

  noteAdded: "Note ajoutée.",
  providerUnreachable: "Impossible de joindre le prestataire de paiement — la connexion est absente ou déconnectée. Vérifiez Paramètres → Paiements.",
  providerReports: "Statut indiqué par le prestataire : {status}.",
  cancelReasonRequired: "Indiquez un motif d’annulation.",
  refundAmountRequired: "Indiquez un montant à rembourser.",
  enterAmount: "Indiquez un montant",
  refundOfFailed: "Le remboursement de {amount} a échoué : {error}. Aucun argent n’a été transféré.",
  refundFailedMsg: "Le remboursement a échoué : {error}. Aucun argent n’a été transféré.",
  providerDeclined: "refusé par le prestataire",
  stillPending: "Toujours en attente chez le prestataire.",
  returnNotInOrder: "Ce retour n’appartient pas à cette commande.",
  notesSaved: "Notes et étiquettes enregistrées.",
  unsubscribedSaved: "Désinscrit du marketing.",

  order: "Commande",
  orderNumber: "Commande n° {number}",
  customer: "Client",
  payment: "Paiement",
  fulfillment: "Expédition",
  reason: "Motif",
  reasonLabel: "Motif :",
  yourNote: "Votre note :",
  instructionsLabel: "Instructions :",
  note: "Note",
  internalNote: "Note interne",
  ofQuantity: "sur {count}",
  itemFallback: "Article",
  exportCsv: "Exporter en CSV",
  exportCsvFiltered: "Exporter en CSV (filtré)",
  subscribed: "Abonné",
  notSubscribed: "Non abonné",

  ordersTitle: "Commandes",
  ordersDescription: "Toutes les commandes passées dans votre boutique, y compris celles en attente de paiement.",
  searchPlaceholderPii: "N° de commande, e-mail ou nom",
  searchPlaceholder: "N° de commande",
  anyStatus: "Tous les statuts",
  anyPayment: "Tous les paiements",
  anyFulfillment: "Toutes les expéditions",
  from: "Du",
  to: "Au",
  sort: "Trier",
  sortNewest: "Plus récentes",
  sortOldest: "Plus anciennes",
  sortTotalDesc: "Total : décroissant",
  sortTotalAsc: "Total : croissant",
  noOrdersMatch: "Aucune commande ne correspond",
  noOrdersMatchHint: "Essayez d’autres filtres ou d’autres dates.",
  resetFilters: "Réinitialiser les filtres",
  noOrdersYet: "Aucune commande pour l’instant",
  noOrdersYetHint: "Les commandes de vos clients apparaîtront ici — y compris celles en paiement à la livraison ou par virement en attente de règlement.",
  colMethod: "Mode",
  itemCount: "{count} articles",
  itemCount_one: "{count} article",

  placedOn: "Passée le {date}",
  cancelOrder: "Annuler la commande",
  cancelOrderTitle: "Annuler la commande n° {number} ?",
  cancelPaidOnline: "Cette commande a été payée ({amount} non encore remboursés). L’annulation {refundsFirst} via {provider} ; la commande n’est annulée que si le remboursement réussit.",
  cancelPaidOffline: "Cette commande a été payée ({amount} non encore remboursés). L’annulation {refundsFirst} (enregistré comme remboursement manuel — remboursez vous-même) ; la commande n’est annulée que si le remboursement réussit.",
  refundsFirst: "rembourse d’abord le paiement",
  cancelNoRefundRole: "Votre rôle ne permet pas d’effectuer des remboursements : vous ne pouvez donc pas annuler une commande payée.",
  cancelUnpaid: "Cette commande n’a aucun paiement encaissé. Le stock réservé est libéré et l’utilisation éventuelle d’un code de réduction est restituée. Le client est prévenu.",
  restockItems: "Remettre en stock",
  restockOrderedHint: "Remettre les quantités commandées dans le stock.",
  orderCancelledTitle: "Commande annulée",
  testOrderInfo: "Ceci est une commande en mode test. Aucun argent réel n’a été débité.",
  items: "Articles",
  colProduct: "Produit",
  colQty: "Qté",
  colUnit: "Prix unitaire",
  colDiscount: "Réduction",
  colTax: "Taxe",
  colFulfilled: "Expédié",
  sku: "Réf. {sku}",
  digital: "Numérique",
  restockedCount: "{count} remis en stock",
  notApplicable: "s.o.",
  subtotal: "Sous-total",
  discount: "Réduction",
  shipping: "Livraison",
  shippingWithMethod: "Livraison ({method})",
  taxLine: "{name} {rate} %",
  taxLineIncluded: "{name} {rate} % (incluse)",
  tax: "Taxe",
  taxIncluded: "Taxe (incluse)",
  paid: "Payé",
  refunded: "Remboursé",
  refundable: "Remboursable",
  customerNote: "Note du client",
  nothingToShip: "Rien dans cette commande ne nécessite de livraison.",
  shipmentN: "Expédition {n}",
  shippedOn: "Expédiée le {date}",
  shippedOnBy: "Expédiée le {date} par {name}",
  deliveredOn: "livrée le {date}",
  customerNotified: "client prévenu",
  markDelivered: "Marquer comme livrée",
  track: "Suivre",
  createShipment: "Créer une expédition",
  shipAfterPayment: "Expédiez cette commande une fois son paiement confirmé.",
  shipAfterPaymentOffline: "Expédiez cette commande une fois son paiement confirmé (marquez d’abord le paiement comme reçu).",
  allFulfilled: "Tous les articles ont été expédiés.",
  noShipments: "Aucune expédition pour l’instant.",
  refunds: "Remboursements",
  refundsSummary: "{refunded} remboursés sur {paid} payés",
  via: "via {provider}",
  manualOffline: "manuel (hors ligne)",
  providerRef: "réf. {ref}",
  restockedN: "{count} remis en stock",
  checkRefundStatus: "Vérifier le remboursement",
  refundPendingAlert: "Un remboursement est en attente chez le prestataire. Son montant est déduit du total remboursable jusqu’à ce qu’il aboutisse ou échoue.",
  nothingToRefund: "Plus rien à rembourser.",
  returns: "Retours",
  requestedOn: "Demandé le {date}",
  timeline: "Historique",
  timelineHint: "Les notes sont internes et ne sont jamais montrées au client.",
  addNotePlaceholder: "Ajouter une note interne…",
  adding: "Ajout…",
  addNote: "Ajouter la note",
  noEvents: "Aucun événement pour l’instant.",
  eventSystem: "système",
  eventInternalNote: "note interne",
  eventInternal: "interne",
  eventVisible: "visible par le client",
  noPaymentRecord: "Aucun paiement enregistré.",
  captured: "Encaissé",
  paymentRef: "Réf. paiement",
  providerReference: "Référence du prestataire",
  checkoutRef: "Réf. checkout",
  lastUpdate: "Dernière mise à jour",
  refreshFromProvider: "Actualiser le statut auprès du prestataire",
  codInfo: "Paiement à la livraison : encaissez le paiement, puis enregistrez-le ici.",
  bankTransferInfo: "Virement bancaire : marquez la commande comme payée dès que les fonds arrivent sur votre compte.",
  markPaymentReceived: "Marquer le paiement comme reçu",
  markPaymentReceivedTitle: "Marquer le paiement comme reçu ?",
  markAsPaid: "Marquer comme payée",
  markPaidBody: "Enregistre {amount} comme reçus pour la commande n° {number}. Cette action est {audited} avec votre nom et est irréversible — en cas d’erreur, vous devrez enregistrer un remboursement.",
  audited: "consignée dans l’audit",
  paidNoteHint: "Ex. : référence du virement ou personne ayant encaissé les espèces.",
  paidOn: "Payée le {date}",
  guestCheckout: "Commande en tant qu’invité",
  customerOrdersSpent: "{count} commandes · {amount} dépensés",
  customerOrdersSpent_one: "{count} commande · {amount} dépensés",
  shippingAddress: "Adresse de livraison",
  billingAddress: "Adresse de facturation",
  sameAsShipping: "Identique à l’adresse de livraison",
  customerHidden: "Informations client masquées",
  customerHiddenHint: "Votre rôle ne donne pas accès aux informations des clients.",

  itemsToShip: "Articles à expédier",
  alreadyShipped: "{count} déjà expédié(s)",
  carrier: "Transporteur",
  trackingNumber: "Numéro de suivi",
  trackingUrl: "URL de suivi",
  trackingUrlHint: "Doit commencer par https://",
  notifyShipping: "Envoyer au client une confirmation d’expédition par e-mail",
  notifyShippingHint: "Inclut les informations de suivi si elles sont fournies.",
  creatingShipment: "Création de l’expédition…",

  refundOnlineInfo: "Le remboursement est envoyé via {provider} — le prestataire utilisé par le client pour payer — sur son moyen de paiement d’origine. Il peut mettre plusieurs jours ouvrés à apparaître.",
  refundOfflineInfo: "Cette commande a été payée par {provider}. Le remboursement est {recorded} ici et met à jour les totaux de la commande, mais aucun argent n’est transféré automatiquement — remboursez vous-même le client (espèces, virement…).",
  recorded: "enregistré",
  refundAmount: "Montant à rembourser",
  refundAmountHint: "Jusqu’à {amount} peuvent être remboursés.",
  refundReasonHint: "Conservé sur la commande pour vos archives.",
  restockHint: "Remettre ces quantités en stock lorsque le remboursement réussit. Laissez 0 si les articles ne sont pas retournés.",
  refunding: "Remboursement…",
  refundVia: "Rembourser via {provider}",
  recordRefund: "Enregistrer le remboursement",

  approve: "Approuver",
  approveReturn: "Approuver le retour",
  approveBody: "Le client est informé que le retour est approuvé et voit vos instructions.",
  returnInstructions: "Instructions de retour",
  returnInstructionsHint: "Ex. : où envoyer les articles et quoi joindre.",
  reject: "Refuser",
  rejectReturn: "Refuser le retour",
  rejectBody: "Le client verra votre note.",
  noteToCustomer: "Note au client",
  markReceived: "Marquer comme reçu",
  markItemsReceived: "Marquer les articles comme reçus",
  receiveBody: "Confirme que les articles retournés sont arrivés. Vous pourrez rembourser ensuite.",
  refundReturn: "Rembourser le retour",
  refundThisReturn: "Rembourser ce retour",
  refund: "Rembourser",
  refundReturnOnline: "Le remboursement est renvoyé via le prestataire de paiement d’origine sur le moyen de paiement du client.",
  refundReturnOffline: "Paiement hors ligne : le remboursement est seulement enregistré — remboursez vous-même le client.",
  suggestedHint: "Suggestion : la part des articles retournés dans le total de leurs lignes.",
  restockReturned: "Remettre en stock les articles retournés",
  closeReturn: "Clôturer le retour",
  closeBody: "Clôture la demande sans autre modification.",

  returnsDescription: "Demandes de retour envoyées par les clients depuis la page de leur commande. Approuvez-les, réceptionnez-les et remboursez-les ici ou depuis la commande.",
  noReturnsWithStatus: "Aucun retour avec le statut « {status} »",
  noReturnRequests: "Aucune demande de retour",
  noReturnsHint: "Lorsqu’un client demande à retourner des articles, la demande apparaît ici.",
  suggestedRefund: "Remboursement suggéré : {suggested} · {refundable} remboursables sur la commande",

  customersTitle: "Clients",
  customersDescription: "Les personnes ayant commandé dans votre boutique ou créé un compte. Créés automatiquement lors du paiement.",
  segmentRepeat: "Clients fidèles",
  segmentSubscribers: "Abonnés e-mail",
  segmentAccounts: "Avec un compte",
  segmentNoOrders: "Sans commande",
  customerSearchPlaceholder: "Nom, e-mail ou téléphone",
  tag: "Étiquette",
  exactTag: "Étiquette exacte",
  noCustomersMatch: "Aucun client ne correspond",
  noCustomersMatchHint: "Essayez une autre recherche, étiquette ou segment.",
  showAll: "Tout afficher",
  noCustomersYet: "Aucun client pour l’instant",
  noCustomersYetHint: "Les clients apparaissent ici après leur première commande ou lorsqu’ils créent un compte dans votre boutique.",
  colOrders: "Commandes",
  colSpent: "Dépensé",
  colMarketing: "Marketing",
  colLastOrder: "Dernière commande",

  account: "Compte",
  guest: "Invité",
  customerSince: "Client depuis le {date}",
  totalSpent: "Total dépensé",
  avgOrder: "Panier moyen",
  showing50: "Affichage des 50 plus récentes.",
  refundedAmount: "−{amount} remboursés",
  notesTags: "Notes et étiquettes",
  notesTagsHint: "Interne — jamais montré au client.",
  tags: "Étiquettes",
  tagsHint: "Appuyez sur Entrée ou virgule pour ajouter. Utilisez les étiquettes pour filtrer les clients.",
  noTags: "Aucune étiquette",
  noNote: "Aucune note",
  contact: "Contact",
  hasStoreAccount: "Possède un compte client",
  guestNoPassword: "Invité (sans mot de passe)",
  emailMarketing: "Marketing par e-mail",
  consentGiven: "Consentement donné",
  unsubscribed: "Désinscrit",
  optInInfo: "Seuls les clients peuvent s’abonner, lors du paiement ou depuis leur compte. Vous pouvez les désinscrire à leur demande, mais pas les inscrire.",
  unsubscribeFromMarketing: "Désinscrire du marketing",
  unsubscribeTitle: "Désinscrire ce client ?",
  unsubscribe: "Désinscrire",
  unsubscribeBody: "Il ne recevra plus d’e-mails marketing. Les e-mails de commande et de livraison ne sont pas concernés. Seul le client peut se réabonner.",
  addresses: "Adresses",
  noSavedAddresses: "Aucune adresse enregistrée.",
  defaultAddress: "Par défaut",
};

export default fr;
